import withLogger, { LoggerConsumer } from 'AppShell/logger/LoggerProvider';
import React, { ReactElement } from 'react';
import { errorToJson } from 'Utils/errors/errorToJson';

export interface ErrorBoundaryState {
    hasError: boolean;
}

export interface ErrorBoundaryProps {
    // e.g.: Header, footer ...
    boundaryName: string;
    fallbackComponent: ReactElement | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps & LoggerConsumer, ErrorBoundaryState> {
    public constructor(props: ErrorBoundaryProps & LoggerConsumer) {
        super(props);
        this.state = { hasError: false };
    }

    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        const { logger, boundaryName } = this.props;
        logger.error(`ErrorBoundary: ${boundaryName} ${error.message}`, {
            error: errorToJson(error),
            errorInfo,
        });
    }

    public render() {
        const { hasError } = this.state;
        const { fallbackComponent } = this.props;
        if (hasError) {
            return fallbackComponent;
        }
        const { children } = this.props;
        return children || null;
    }
}

export default withLogger(ErrorBoundary);
